import {JSX, ReactNode} from "react";

import type {BookingSummaryRow} from "../../types";

import "./summary-row.scss";

interface SummaryRowProps extends BookingSummaryRow {
    children?: ReactNode;
}

export function SummaryRow({label, amount, bold, highlighted, highlightedPlain, discount, children}: SummaryRowProps): JSX.Element {
    const className = `summary-row${bold ? " summary-row--bold" : ""}${highlighted ? " summary-row--highlighted" : ""}${highlightedPlain ? " summary-row--highlighted-plain" : ""}${discount ? " summary-row--discount" : ""}`;
    return (
        <div className={className}>
            <div className="summary-row__label">{label}</div>
            {amount !== undefined && <div className="summary-row__amount">{amount}</div>}
            {children}
        </div>
    );
}
